export default __webpack_public_path__ + "static/media/thunderbird-mail.c28bf488.svg";